export default __webpack_public_path__ + "static/lan-traffic-3be78b688be531e2d9ce5b6a9315ba21.png";